'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _util = require('./util');

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

var _datepickerLocal = require('./datepicker.local.css');

var _datepickerLocal2 = _interopRequireDefault(_datepickerLocal);

var _yearBar = require('./year-bar');

var _yearBar2 = _interopRequireDefault(_yearBar);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var MonthGrid = function (_Component) {
  _inherits(MonthGrid, _Component);

  function MonthGrid() {
    _classCallCheck(this, MonthGrid);

    return _possibleConstructorReturn(this, (MonthGrid.__proto__ || Object.getPrototypeOf(MonthGrid)).apply(this, arguments));
  }

  _createClass(MonthGrid, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          selectedPeriod = _props.selectedPeriod,
          setCurrentYear = _props.setCurrentYear,
          id = _props.id;

      if (selectedPeriod.date) {
        setCurrentYear((0, _momentTimezone2.default)(selectedPeriod.date).year(), id);
      }
    }
  }, {
    key: 'renderHalfYearButton',
    value: function renderHalfYearButton(halfyear, firstQuarter, firstYear, secondQuarter, secondYear) {
      var _classnames;

      var _props2 = this.props,
          hasPermissionForHalfYear = _props2.hasPermissionForHalfYear,
          allowHalfYears = _props2.allowHalfYears,
          setPeriod = _props2.setPeriod,
          selectedPeriod = _props2.selectedPeriod;
      var isDisabled = !allowHalfYears || !hasPermissionForHalfYear({
        firstQuarter: firstQuarter,
        firstYear: firstYear
      }, {
        secondQuarter: secondQuarter,
        secondYear: secondYear
      });
      return _react2.default.createElement('button', {
        className: (0, _classnames3.default)(_datepickerLocal2.default.halfYearButton, _datepickerLocal2.default.button, (_classnames = {}, _defineProperty(_classnames, _datepickerLocal2.default.active, (0, _util.isInPeriod)(selectedPeriod, {
          halfyear: halfyear,
          year: firstYear
        })), _defineProperty(_classnames, _datepickerLocal2.default.first, halfyear === 0), _defineProperty(_classnames, _datepickerLocal2.default.last, halfyear === 4), _defineProperty(_classnames, _datepickerLocal2.default.disabled, isDisabled), _classnames)),
        disabled: isDisabled,
        id: 'halfyear' + halfyear,
        onMouseEnter: function onMouseEnter() {
          return setPeriod('hovering', 'halfyear', {
            halfyear: halfyear,
            year: firstYear
          });
        },
        onMouseLeave: function onMouseLeave() {
          return setPeriod('hovering', '', {});
        },
        onClick: function onClick() {
          return setPeriod('selected', 'halfyear', {
            halfyear: halfyear,
            year: firstYear
          });
        }
      }, '+');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          currentYear = _props3.currentYear,
          other = _objectWithoutProperties(_props3, ['currentYear']);

      var QUARTERS = _constants2.default.QUARTERS;
      return _react2.default.createElement('div', null, this.renderHalfYearButton(0, 4, currentYear - 1, 1, currentYear), [1, 2, 3, 4].map(function (quarterNumber) {
        var quarter = QUARTERS[quarterNumber];
        return _react2.default.createElement('div', {
          key: quarter.label
        }, _react2.default.createElement(_yearBar2.default, _extends({
          quarter: quarterNumber,
          year: currentYear,
          isCurrentYear: true
        }, other)), quarterNumber !== 4 ? _this2.renderHalfYearButton(quarterNumber, quarterNumber, currentYear, quarterNumber + 1, currentYear) : _this2.renderHalfYearButton(quarterNumber, 4, currentYear, 1, currentYear + 1));
      }));
    }
  }]);

  return MonthGrid;
}(_react.Component);

MonthGrid.propTypes = {
  currentYear: _propTypes2.default.number,
  allowHalfYears: _propTypes2.default.bool,
  selectedPeriod: _propTypes2.default.shape({
    type: _propTypes2.default.string,
    date: _propTypes2.default.string
  }).isRequired,
  hoveringPeriod: _propTypes2.default.shape({
    type: _propTypes2.default.string,
    date: _propTypes2.default.string
  }).isRequired,
  id: _propTypes2.default.string.isRequired,
  setPeriod: _propTypes2.default.func.isRequired,
  setCurrentYear: _propTypes2.default.func.isRequired,
  hasPermissionForMonth: _propTypes2.default.func.isRequired,
  hasPermissionForHalfYear: _propTypes2.default.func.isRequired,
  hasPermissionForQuarter: _propTypes2.default.func.isRequired
};
exports.default = MonthGrid;